import { useWindowSize } from "react-use";

const breakpoints = {
  mobile: 0,
  tablet: 768,
  laptop: 1024,
  desktop: 1280,
  largeDesktop: 1440,
  wide: 1536,
};

const useBreakpoint = () => {
  const { width } = useWindowSize();

  return {
    width,
    isMobile: width < breakpoints.tablet,
    isTablet: width >= breakpoints.tablet && width < breakpoints.laptop,
    isLaptop: width >= breakpoints.laptop,
    isWide: width >= breakpoints.largeDesktop,
  };
};

export default useBreakpoint;
